/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const Toast = ({ message, type,setToastmessage }) => {
    const [showToast, setShowToast] = useState(true);

    /* This `useEffect` hook is setting a timer using `setTimeout` function to hide the toast message
    after 5 seconds (5000 milliseconds) and also resetting the `toastMessage` state to an empty
    string. The `clearTimeout` function is used to clear the timer when the component unmounts. The
    empty dependency array `[]` ensures that this effect runs only once when the component mounts. */
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowToast(false);
            setToastmessage('')
        }, 7000);

        return () => {
            clearTimeout(timer);
            setShowToast(true)
        };
    });
    return (
        <>
            {showToast && message && message!=='' &&(
                <div className={`items-center alert alert-dismissible fade ${type === 'error' ? " left-[50%] -translate-x-[50%] absolute" : "right-3 absolute"} min-w-max top-[10px] z-[999] absolute shadow-s2 rounded-lg ${type}`}>
                    <motion.div
                        initial={type === 'error' ? { y: -1000 } : { x: 1000 }}
                        animate={type === 'error' ? { y: 0 } : { x: 0}}
                        transition={{ duration: 1 }}
                        exit={{ opacity: 0.5 }}
                        onClick={()=>{setShowToast(!showToast); setToastmessage('')}}
                    
                    >
                        <motion.div
                            initial={{ opacity: 0, x: -10 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ delay: 0.2, duration: 0.3 }}
                            exit={{ opacity: 0.5 }}
                            className={`flex items-center justify-center  border-[1.5px]  ${type === 'error' ? "bg-[#FFD6D3] border-[#F04438]" : "bg-[#C5FFD5] border-[#00CF3A]"} rounded-[7px] cursor-pointer px-5 pr-7 py-[18px]`}
                        >
                            <span>
                                {type === 'success' && <img loading="lazy" src="/images/success-mark.svg" alt="icon" />}
                                {type === 'error' && <img loading="lazy" src="/images/error-mark.svg" alt="icon" />}
                                {/* Add other icon options as needed */}
                            </span>
                            <p className="text-f1 text-[#000000] font-normal pl-5" id="toast-message">{message}</p>
                        </motion.div>
                    </motion.div>
                </div>
            )}
        </>
    );
};

export default Toast;
